import { useState, useEffect } from "react";
import * as Material from "@mui/material";
import "../styles.scss";

import { Text } from "@fragments"

const SwitchInput = ({
    value = false,
    onInput,
    label,
    left,
    right,
    disabled = false,
    size,
    fullWidth = false,
    className = '',
    ...props
}) => {
    const [isChecked, setIsChecked] = useState(value);

    // Sync internal state with external checked prop
    useEffect(() => {
        setIsChecked(value);
    }, [value]);

    const handleToggle = () => {
        if (disabled) return;

        const newValue = !isChecked;
        setIsChecked(newValue);

        if (onInput) {
            onInput(newValue);
        }
    };

    return (
        <div
            className={`CustomInput_switch ${isChecked ? 'checked' : ''} ${disabled ? 'disabled' : ''} ${size === 'small' ? 'size-small' : ''} ${fullWidth ? 'full-width' : ''} ${className}`.trim()}
            onClick={handleToggle}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
            {left && <span className="switch-left">{left}</span>}

            <Material.Switch
                checked={isChecked}
                onChange={handleToggle}
                disabled={disabled}
                color="secondary"
                onClick={(e) => e.stopPropagation()} // Prevent double toggle
                {...props}
            />

            {(label || right) && (
                <span className="switch-right">
                    {label && (size === 'small'
                        ? <Text.span className="switch-label" value={label} />
                        : <Text.h5 className="switch-label" value={label} />
                    )}
                    {right}
                </span>
            )}
        </div>
    );
};

export default SwitchInput;
